import React, { useState } from 'react';

import ErrorPanel from '../../shared/components/ErrorPanel';
import LessonLaunchParamsV2 from '../models/LessonLaunchParamsV2';
import LessonOpenMessageBox from './LessonOpenMessageBox';
import Overlay from '../../shared/components/Overlay';
import useXApiLessons from '../hooks/useXApiLessons';

interface LessonPlayerXapiProps {
  launchParamsV2: LessonLaunchParamsV2;
  preview: boolean;
  onMessage: (event?: MessageEvent) => void;
}

const LessonPlayerXapi = (props: LessonPlayerXapiProps) => {
  const {
    lessonWindow,
    title,
    lessonkey,
    lessonVersion,
    status,
    layer
  } = props.launchParamsV2;
  const [lessonLoading, setLessonLoading] = useState(true);

  const { loading, error, url } = useXApiLessons(
    lessonkey,
    lessonVersion,
    status,
    layer,
    props.preview
  );

  const handleMessage = (event: MessageEvent) => {
    if (url.startsWith(event.origin)) {
      window.removeEventListener('message', handleMessage);
      props.onMessage(event);
    }
  };

  function closeLesson() {
    lessonWindow.close();
    window.removeEventListener('message', handleMessage);
    props.onMessage();
  }

  const onLessonLoad = () => {
    if (lessonLoading) {
      setLessonLoading(false);
    }
    window.addEventListener('message', handleMessage);
  };

  if (loading) {
    return <Overlay spinner message="Loading..." />;
  }
  if (error) {
    props.onMessage();
    return (
      <ErrorPanel title="There was a problem while loading an xAPI lesson." />
    );
  }

  if (url && lessonWindow) {
    lessonWindow.location.href = url;
    onLessonLoad();
  }

  return <LessonOpenMessageBox title={title} onConfirm={closeLesson} />;
};

export default LessonPlayerXapi;
